<template>
    <div class="clickable-tile" @click.capture="navigate">
        <div class="icon">
            <slot name="icon">
                <i class="fa fa-lg fa-gears"></i>
            </slot>
        </div>
        <div class="text">
            <slot></slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ClickableTile',
        props: {
            to: {
                type: Object,
                required: true,
            },
        },
        methods: {
            navigate() {
                this.$router.push(this.to);
            }
        }
    }
</script>
<style lang="scss" scoped>
    .clickable-tile {
        width: 100%;
        padding: 20px;
        background-color: #ffffff;
        color: #c1006d;
        display: flex;
        align-items: center;
        flex-direction: column;
        cursor: pointer;
        box-shadow: 3px 1px 5px #ccc;

        .icon {
            font-size: 5em;
            color: #230a62;
        }

        .text {
            margin-top: 15px;
        }

        &:hover {
            background-color: #f9f9f9;
        }
    }

</style>